import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as c } from "../../../../IconBase-CxZyIWw2.js";
const r = e((i, l) => /* @__PURE__ */ s.jsx(
  c,
  {
    ref: l,
    ...i,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...a,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4154)", children: [
            /* @__PURE__ */ s.jsx(
              "mask",
              {
                id: "mask0_2974_4154",
                width: 33,
                height: 32,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M39.25 38.5H27.74L39.8 25.25c.2-.22.25-.54.13-.81a.725.725 0 0 0-.68-.44H19.47L16.13 8.59A.75.75 0 0 0 15.4 8a.75.75 0 0 0-.73.59L11.33 24H8.75a.749.749 0 1 0 0 1.5H11L8.06 39.09c-.09.41.17.8.57.89.41.08.8-.17.89-.57l3.02-13.91h5.72l3.02 13.91c.08.35.39.59.73.59a.75.75 0 0 0 .73-.91L19.8 25.5h17.75L25.49 38.74a.753.753 0 0 0 .56 1.26h13.21c.41 0 .75-.34.75-.75s-.35-.75-.76-.75M12.86 24l2.54-11.71L17.94 24z"
                  }
                )
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4154)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h48v48H0z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4154", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
r.displayName = "AgencyAzelaicAcidIcon";
export {
  r as AgencyAzelaicAcidIcon,
  r as default
};
//# sourceMappingURL=index.js.map
